import React from 'react';
import ReactDOM from 'react-dom';
interface ConfirmationProps {
  onClose: () => void;
  onConfirm: () => void;
  isApproval?: string;
  statusValue: string;
  isUpdate: string;
  role?: string;
}
const AddEventConfirmationModal: React.FC<ConfirmationProps> = ({
  onClose,
  onConfirm,
  isApproval,
  statusValue,
  isUpdate,
  role,
}) => {
  return ReactDOM.createPortal(
    <div className='fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30'>
      <div className='bg-white rounded-lg shadow-lg overflow-hidden sm:w-1/3 md:w-1/3 w-10/12'>
        <div className='p-4'>
          <div className='flex items-center justify-center'>
            <div className='ml-4'>
              <>
                {isApproval === 'draft' && (
                  <>
                    <h3 className='text-lg font-medium text-gray-900 text-center'>
                      Save as Draft?
                    </h3>
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to save this event as a draft? You
                      can save your progress and submit it for review once it's
                      ready.
                    </p>
                  </>
                )}
                {isApproval === 'approval' && (
                  <>
                    <h3 className='text-lg font-medium text-gray-900 text-center'>
                      {statusValue === 'SAVED_AS_DRAFT' && role === 'Publisher'
                        ? 'Send Approval to Publisher'
                        : statusValue === 'SAVED_AS_DRAFT' &&
                          role !== 'JE' &&
                          role !== 'CE'
                        ? 'Confirm Event Publication'
                        : isUpdate === 'update' && statusValue === 'PUBLISHED'
                        ? 'Confirm Overwrite'
                        : role === 'CE'
                        ? 'Send Approval to Chief Editor?'
                        : role === 'JE'
                        ? 'Send Approval to Junior Editor?'
                        : role === 'Publisher'
                        ? 'Send Approval to Publisher?'
                        : ''}
                    </h3>

                    <p className='text-base text-gray-500 text-center mt-2'>
                      {statusValue === 'SAVED_AS_DRAFT' && role === 'Publisher'
                        ? "Are you sure you want to send this event for approval to the Publisher? Once submitted, you won't be able to make further edits."
                        : statusValue === 'SAVED_AS_DRAFT' &&
                          role !== 'JE' &&
                          role !== 'CE'
                        ? 'Are you sure you want to publish this event? Once published, it will be live for readers to view.'
                        : isUpdate === 'update' && statusValue === 'PUBLISHED'
                        ? 'Are you sure you want to publish these changes? This will overwrite the previously published content for this event.'
                        : role === 'JE'
                        ? "Are you sure you want to send this event for approval to the Junior Editor? Once submitted, you won't be able to make further edits."
                        : role === 'CE'
                        ? "Are you sure you want to send this event for approval to the Chief Editor? Once submitted, you won't be able to make further edits."
                        : role === 'Publisher'
                        ? "Are you sure you want to send this event for approval to the Publisher? Once submitted, you won't be able to make further edits."
                        : 'Are you sure you want to publish this event? Once published, it will be visible to all users.'}
                    </p>
                  </>
                )}
              </>
            </div>
          </div>
        </div>
        <div
          className='bg-white px-4 py-3 sm:px-6 sm:flex justify-center sm:flex-row-revers'
          style={{
            boxShadow: '0px -16px 50px 0px #0000000D',
          }}
        >
          <button
            type='button'
            className='mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm'
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type='button'
            className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mr-2'
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddEventConfirmationModal;
